// src/components/AppointmentBooked.js
import React from 'react';
import './AppointmentBooked.css';

const AppointmentBooked = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const appointmentId = urlParams.get('appointmentId');
  const patientuserid = urlParams.get('patientuserid');

  const goToDashboard = () => {
    window.location.href = `/patient-dashboard/${patientuserid}`;
  };

  const tryAgain = () => {
    window.location.href = '/book-appointment';
  };

  return (
    <div className="appointment-booked-page">
      <h2>Appointment Booked</h2>
      {appointmentId && patientuserid ? (
        <div className="success-message">
          <p>Your appointment has been successfully booked with ID: {appointmentId}.</p>
          <p>Payment is pending. You can complete it later or proceed to your dashboard.</p>
          <button onClick={goToDashboard}>
            Go to Dashboard
          </button>
        </div>
      ) : (
        <div className="error-message">
          <p>No appointment ID or patient ID provided. Something went wrong.</p>
          <button onClick={tryAgain}>Try Again</button>
        </div>
      )}
    </div>
  );
};

export default AppointmentBooked;